/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import RoleForm from './RoleForm';
import { getAllRole } from '../../../../../../store/reducers/role/roleAction';
import { editRole } from '../../../../../../services/role/Role';

const RoleEdit = ({ handleClose, selectedRole }) => {
    const dispatch = useDispatch()
    const handleSubmit = async ({ roleName, detailName, detailValue }, { setSubmitting }) => {
        setSubmitting(true);
        try {
             await editRole({
                roleName, roleID: selectedRole.roleID, roleDetails: [
                    {
                        detailName: detailName,
                        detailValue: detailValue
                    }]
            })
            toast.success('Role was edited successfully');
            handleClose();
            await dispatch(getAllRole()).unwrap();
            setSubmitting(false)
        } catch (error) {

            setSubmitting(false)

            toast.error(error?.response?.data?.error?.message)
        }
    }

    return (
        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Role Edit</Typography>
            <Formik
                initialValues={{
                    roleName: selectedRole.roleName,
                    detailName: selectedRole.roleDetails[0].detailName,
                    detailValue: selectedRole.roleDetails[0].detailValue,

                }}
                validationSchema={Yup.object().shape({
                    roleName: Yup.string().min(2).max(40).required('Role Name is required.')
                })}
                onSubmit={(
                    values, { setSubmitting }
                ) => {
                    handleSubmit(values, { setSubmitting })
                }
                }
            >
                {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (

                    <RoleForm
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        isSubmitting={isSubmitting}
                        handleClose={handleClose}
                        errors={errors}
                        touched={touched}
                    />
                )}
            </Formik>
        </>
    )

}

export default RoleEdit;
